var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserApprove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5C11 7.16406 9.64062 8.5 8 8.5C6.33594 8.5 5 7.16406 5 5.5C5 3.85938 6.33594 2.5 8 2.5C9.64062 2.5 11 3.85938 11 5.5ZM9.94531 9.69531C11.8203 10 13.25 11.6172 13.25 13.5625V13.75C13.25 14.1719 12.8984 14.5 12.5 14.5H3.5C3.07812 14.5 2.75 14.1719 2.75 13.75V13.5625C2.75 11.6172 4.15625 10 6.03125 9.69531L8 12.625L9.94531 9.69531Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserApprove);
export default __webpack_public_path__ + "static/media/user-approve.c8c93670d11f4d9133f9ab486b088079.svg";
export { ForwardRef as ReactComponent };